// AI 会话 API（后端 ProxyServer AgentController，/api/agent/*）
import { multiLanguageHeader } from '@/utils/languageHeader';

const AGENT_START_URL = (import.meta.env.VITE_API_BASE as string || '') + '/api/agent/conversation/start';

export class AgentRateLimitedError extends Error {
  code: number;
  constructor(message: string, code = -7000) {
    super(message);
    this.name = 'AgentRateLimitedError';
    this.code = code;
  }
}

export async function startConversation(signal?: AbortSignal): Promise<string> {
  const res = await fetch(AGENT_START_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...multiLanguageHeader() },
    credentials: 'include',
    body: JSON.stringify({ appId: 'fateuni', agentType: 1 }),
    signal,
  });
  if (!res.ok) {
    throw new Error(`请求失败（HTTP ${res.status}）`);
  }
  const json = await res.json().catch(() => null);
  if (!json || typeof json.status !== 'number') {
    throw new Error('服务响应异常');
  }
  if (json.status === -7000) {
    throw new AgentRateLimitedError(json.message || '今日次数已用完', -7000);
  }
  if (json.status !== 200 || !json.data?.conversationId) {
    throw new Error(json.message || '获取会话失败');
  }
  return json.data.conversationId as string;
}
